module.exports = __webpack_public_path__ + "static/media/INJ.0b6a4e58.png";